import React from "react";

function Contact() {
  return (
    <main>

      {/* ===================== HERO ===================== */}
      <section className="bg-dark position-relative overflow-hidden pt-xl-8" data-bs-theme="dark">
        <div className="position-absolute bottom-0 end-0 mb-n9">
          <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" className="opacity-2 blur-9" alt="Grad shape" />
        </div>
        <div className="container position-relative pt-4 pt-sm-5">
          <span className="h2">👋</span>
          <h1 className="display-5 mt-3">Let's Connect</h1>
          <p className="mb-1">We're here to help</p>
          <p>Support hours: <span className="text-primary fw-bold">24/7</span></p>
        </div>
      </section>

      {/* ===================== CONTACT CARDS ===================== */}
      <section className="pt-0 mt-n6 mt-lg-n7 mt-xl-n8">
        <div className="container">
          <div className="row g-4 g-lg-5">

            <div className="col-md-4">
              <div className="card bg-secondary rounded-4 p-4 h-100">
                <div className="card-body p-0">
                  <div className="icon-lg bg-pink text-white rounded-circle mb-3">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <h6>Call us</h6>
                  <p className="mb-0">Speak with a member of our team. We're always ready to assist you.</p>
                </div>
                <div className="card-footer bg-transparent p-0 pt-3">
                  <a href="tel:7677607080" className="text-primary-grad">+91 76776 07080</a>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card bg-secondary rounded-4 p-4 h-100">
                <div className="card-body p-0">
                  <div className="icon-lg bg-primary text-white rounded-circle mb-3">
                    <i className="bi bi-envelope"></i>
                  </div>
                  <h6>Mail us</h6>
                  <p className="mb-0">We're prompt and aim to respond to all inquiries within 24 hours.</p>
                </div>
                <div className="card-footer bg-transparent p-0 pt-3">
                  <a href="mailto:info@arixautomation.com" className="text-primary-grad">info@arixautomation.com</a>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card bg-secondary rounded-4 p-4 h-100">
                <div className="card-body p-0">
                  <div className="icon-lg bg-warning text-white rounded-circle mb-3">
                    <i className="bi bi-headset"></i>
                  </div>
                  <h6>Support</h6>
                  <p className="mb-0">Check out helpful resources, FAQs and developer tools.</p>
                </div>
                <div className="card-footer bg-transparent p-0 pt-3">
                  <a className="btn btn-sm btn-white-shadow icon-link icon-link-hover" href="https://wa.me/917677607080">
                    Chat now<i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ===================== CONTACT FORM ===================== */}
      <section className="position-relative pt-0">
        <div className="container bg-secondary-grad rounded-4 p-4 p-md-6 p-xxl-8">
          <div className="inner-container-small">

            <h1 className="fw-bold mb-2 lh-base text-center">
              <i className="bi bi-emoji-smile me-2"></i>Say
              <span className="cd-headline clip big-clip is-full-width text-primary-grad mb-0">
                <span className="typed" data-type-text="Hello&&Hola&&Ciao&&Bonjour"></span>
              </span>
            </h1>
            <p className="text-center">Have an idea, need advice, or just want to say hello? We're all ears.</p>

            <form className="row form-border-transparent g-3 mt-4">
              <div className="col-md-6">
                <label className="form-label">Your name</label>
                <input type="text" className="form-control" />
              </div>
              <div className="col-md-6">
                <label className="form-label">Email address</label>
                <input type="email" className="form-control" />
              </div>
              <div className="col-md-6">
                <label className="form-label">Mobile number</label>
                <input type="text" className="form-control" />
              </div>
              <div className="col-md-6">
                <label className="form-label">Subject</label>
                <input type="text" className="form-control" />
              </div>
              <div className="col-12">
                <label className="form-label">Message</label>
                {/* style string → JSX object */}
                <textarea className="form-control" style={{ height: '100px' }}></textarea>
              </div>
              <div className="col-12">
                <div className="form-check">
                  <input type="checkbox" className="form-check-input border" id="contactCheck1" />
                  {/* for → htmlFor */}
                  <label className="form-check-label" htmlFor="contactCheck1">
                    I agree that my data is{' '}
                    <a href="#" className="hover-underline-animation text-primary-hover">collected and stored</a>.
                  </label>
                </div>
              </div>
              <div className="col-12 d-sm-flex align-items-center gap-3 mt-4">
                <button className="btn btn-primary mb-2 mb-md-0">Send a message</button>
                <ul className="list-inline mb-0 ms-auto">
                  <li className="list-inline-item small heading-color">Connect with:</li>
                  <li className="list-inline-item"><a href="https://www.facebook.com/profile.php?id=61593436621403" target="_blank" rel="noreferrer" className="heading-color text-primary-hover"><i className="bi bi-facebook"></i></a></li>
                  <li className="list-inline-item"><a href="https://www.instagram.com/arix.automation" target="_blank" rel="noreferrer" className="heading-color text-primary-hover"><i className="bi bi-instagram"></i></a></li>
                  <li className="list-inline-item"><a href="#" className="heading-color text-primary-hover"><i className="bi bi-twitter-x"></i></a></li>
                  <li className="list-inline-item"><a href="https://www.linkedin.com/company/arixautomation/posts/?feedView=all" target="_blank" rel="noreferrer" className="heading-color text-primary-hover"><i className="bi bi-linkedin"></i></a></li>
                </ul>
              </div>
            </form>

          </div>
        </div>
      </section>

      {/* ===================== MAP + OFFICES ===================== */}
      <section className="position-relative pt-0 overflow-hidden">
        <div className="position-absolute bottom-0 end-0 mb-n3 me-n7 d-none d-xl-block">
          <img src="assets/images/elements/relex-slay.png" className="h-400px h-xxl-500px rtl-flip" alt="" />
        </div>

        <div className="container">
          <div className="row g-4 align-items-center">

            <div className="col-lg-5">
              {/* style string → JSX object, tabindex → tabIndex */}
              <iframe
                className="w-100 h-200px h-lg-500px grayscale rounded-4 d-block mb-3 mb-lg-0"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3668.9397896065216!2d72.54002767439188!3d23.135875979094532!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e82bdbd781623%3A0x2001910b86ec9099!2sVaishnodevi%20Cir%2C%20Ahmedabad%2C%20Gujarat%20382501!5e0!3m2!1sen!2sin!4v1788722294734!5m2!1sen!2sin"
                width="600"
                height="450"
                style={{ border: 0, marginBottom: '-5px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                aria-hidden="false"
                tabIndex="0"
                title="Office location map"
              ></iframe>
            </div>

            <div className="col-lg-7 ps-lg-6">
              <h2 className="mb-4">Our office</h2>

              <div className="row g-4 mb-4">

                <div className="col-md-6">
                  <div className="d-flex align-items-center gap-2">
                    <div className="avatar avatar-xs flex-shrink-0">
                      <img className="avatar-img rounded-circle" src="assets/images/flags/in.svg" alt="India flag" />
                    </div>
                    <h6 className="mb-0">India</h6>
                  </div>
                  <ul className="mb-0 mt-3">
                    <li className="mb-2">Royal Heights, Vaishnodevi Circle, Ahmedabad 382421</li>
                    <li className="mb-2">Call: 7677607080</li>
                    <li className="mb-2">Support time: Monday to Saturday 9:00 am to 5:30 pm</li>
                  </ul>
                </div>

              </div>

              {/* <a className="btn btn-secondary icon-link icon-link-hover" href="#">
                Contact our help center<i className="bi bi-arrow-right"></i>
              </a> */}
            </div>

          </div>
        </div>
      </section>

    </main>
  );
}

export default Contact;
